import api from '@/api'

const { $academic} = api;

const $st = api.$student

export const { $careers, $subjects, $studyPlans, $degrees, $setting } = $academic;

export const { $student } = $st;